module.exports = __webpack_public_path__ + "static/img/清华.8d75702.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/清华.jpg
// module id = pZsa
// module chunks = 1